import { render, staticRenderFns } from "./Datenschutz.vue?vue&type=template&id=02cea9ee&scoped=true&"
import script from "./Datenschutz.vue?vue&type=script&lang=js&"
export * from "./Datenschutz.vue?vue&type=script&lang=js&"
import style0 from "./Datenschutz.vue?vue&type=style&index=0&id=02cea9ee&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02cea9ee",
  null
  
)

export default component.exports